import React, { Component } from 'react'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'

export default class ComponentExplainer extends Component {
    constructor(props) {
        super(props)

        this.state = {}
    }

    componentDidMount() {}
    componentWillUnmount() {}

    render() {
        var style = {}
        if (this.props.elementData.optionFullWidth) style = { flex: '100%' }

        if (this.props.elementData.hint) {
            return (
                <div className='dndEditorv2-dd_toolHolder' style={style}>
                    <p className='dndEditorv2-toolHint'>{this.props.value}</p>
                </div>
            )
        }

        return (
            <div className='dndEditorv2-dd_toolHolder' style={style}>
                <div className='dd_inputTool'>
                    <WarningHolder>{this.props.value}</WarningHolder>
                </div>
            </div>
        )
    }
}
